import AbstractChannel from './AbstractChannel'

type ChannelMap = {[key: string]: string}

class ChannelRegistry {

  #channels: {[key: string]: AbstractChannel} = {}
  map: ChannelMap = {}

  /**
   * Add a channel to the registry.
   */
  register(channel: AbstractChannel) {
    this.#channels[channel.name] = channel
    this.#refreshMap()
  }

  /**
   * Retrieve a registered channel by name.
   */
  find(name: string): AbstractChannel | undefined {
    return this.#channels[name] ?? null
  }

  findTitle(name: string): string {
    return this.#channels[name]?.title ?? name
  }

  /**
   * Retrieve an array of all registered channels, optionally limited to those
   * which support the specified feature(s).
   */
  get(features: string[] = []): AbstractChannel[] {
    return Object.values(this.#channels).filter((channel) => {
      return channel.supports(features)
    })
  }

  /**
   * Returns an array suitable for passing to the items prop of a Vuetify form
   * component.
   */
  getOptions(): object[] {
    return Object.entries(this.#channels).map(([channelName, channel]) => {
      return {value: channelName, title: channel.titleShort}
    })
  }

  /**
   * Update this.map to reflect the current list of registered channels.
   * We need to recalculate the entire map whenever a new channel is registered,
   * because we want the keys to be in alphabetical order.
   */
  #refreshMap(): void {

    const newMap: ChannelMap = {}
    const names = Object.keys(this.#channels).sort()

    names.forEach((name) => {
      newMap[name] = this.#channels[name].title
    })

    this.map = Object.freeze(newMap)

  }

}

export default new ChannelRegistry()
